import { BaseApiResponseModel } from "api/model/BaseApiResponseModel";
import { UserFeatureResponseModel } from "api/repositories/users/model/feature/UserFeatureResponseModel";
import { isEmpty } from "lodash";
import { GrActions, GrDeploy } from "react-icons/gr";
import {
  IoBarChartSharp,
  IoFileTray,
  IoPeopleCircleOutline,
} from "react-icons/io5";
import {
  LuCode,
  LuFile,
  LuFileArchive,
  LuFileBox,
  LuFileCode,
  LuFlag,
  LuHistory,
  LuKeyRound,
  LuPackage,
  LuPackage2,
  LuSettings,
  LuTicketCheck,
  LuTruck,
  LuUserRound,
  LuUsers,
  LuWarehouse,
  LuWebhook,
} from "react-icons/lu";
import {
  MdOutlineFeaturedPlayList,
  MdOutlineInventory2,
  MdOutlineWarehouse,
} from "react-icons/md";
import { PiFolderUserBold } from "react-icons/pi";
import {
  TbArrowsExchange,
  TbBuildingWarehouse,
  TbWallet,
} from "react-icons/tb";
import { VscTools } from "react-icons/vsc";
import { findElement } from "utils/helpers";
import { strings } from "utils/localizeStrings";
import {
  MenuConfigModel,
  SidebarConfigModel,
} from "./model/SidebarConfigModel";

export type IConfigRepository = {
  getSidebarMenu(
    // role: string
    feature: UserFeatureResponseModel[]
  ): Promise<BaseApiResponseModel<SidebarConfigModel>>;
};

export class SidebarConfigRepository implements IConfigRepository {
  getSidebarMenu(
    // role: string,
    feature: UserFeatureResponseModel[]
  ): Promise<BaseApiResponseModel<SidebarConfigModel>> {
    return new Promise((resolve, reject) => {
      let menuConfig = [];
      let baseMenu: MenuConfigModel[] = [
        findElement("statistical-transaction", feature) ||
        findElement("report-statistical-transaction", feature)
          ? new MenuConfigModel(
              strings.Sidebar.Generals,
              "/generals",
              "StatisticalTransactionFeature",
              <IoBarChartSharp />,
              []
            )
          : undefined,
        findElement("list-transaction", feature) &&
          new MenuConfigModel(
            strings.Sidebar.History,
            "/history",
            "",
            <LuHistory />,
            [
              new MenuConfigModel(
                strings.Sidebar.TransactionHistory,
                "/history/transactions-history",
                "TransactionHistoryFeature",
                <TbArrowsExchange />
              ),
            ]
          ),
        new MenuConfigModel(
          strings.Sidebar.Goods,
          "/goods",
          "",
          <LuPackage2 />,
          [
            findElement("list-goods", feature) &&
              new MenuConfigModel(
                strings.Sidebar.Products,
                "/goods/goods-management",
                "GoodsManagementFeature",
                <LuPackage />,
                []
              ),
            findElement("list-item", feature) &&
              new MenuConfigModel(
                strings.ItemsManagement.Label,
                "/goods/item-management",
                "ItemManagementFeature",
                <LuWarehouse />,
                []
              ),
            findElement("list-field", feature) &&
              new MenuConfigModel(
                strings.Sidebar.Fields,
                "/goods/field-management",
                "FieldManagementFeature",
                <TbBuildingWarehouse />,
                []
              ),
            findElement("list-category", feature) &&
              new MenuConfigModel(
                strings.Sidebar.Category,
                "/goods/category-management",
                "CategoryManagementFeature",
                <TbBuildingWarehouse />,
                []
              ),
            findElement("list-variant", feature) &&
              new MenuConfigModel(
                strings.Sidebar.Variant,
                "/goods/variant-management",
                "VariantManagementFeature",
                <TbBuildingWarehouse />,
                []
              ),
          ]
        ),
        new MenuConfigModel(
          strings.Sidebar.WarehouseManagement,
          "/storages",
          "",
          <IoFileTray />,
          [
            findElement("list-storage", feature) &&
              new MenuConfigModel(
                strings.StoragesManagement.CardTitle,
                "/storages/storage-management",
                "StorageManagementFeature",
                <MdOutlineWarehouse />,
                []
              ),
            findElement("list-inventory", feature) &&
              new MenuConfigModel(
                strings.Sidebar.Inventory,
                "/storages/inventory-management",
                "InventoryManagementFeature",
                <MdOutlineInventory2 />,
                []
              ),
          ]
        ),
        new MenuConfigModel(
          strings.Sidebar.Partner,
          "/partners",
          "partner",
          <PiFolderUserBold />,
          [
            findElement("list-partner", feature) &&
              new MenuConfigModel(
                strings.Sidebar.Partners,
                "/partners/partner-management",
                "PartnerMangementFeature",
                <IoPeopleCircleOutline />,
                []
              ),
            findElement("list-wallet", feature) &&
              new MenuConfigModel(
                strings.WalletManagement.MainTitle,
                "/partners/wallet-management",
                "WalletManagementFeature",
                <TbWallet />,
                []
              ),
            findElement("list-customer-profile", feature) &&
              new MenuConfigModel(
                strings.Sidebar.CustomerProfile,
                "/partners/profile-management",
                "CustomerProfileManagementFeature",
                <LuFile />,
                []
              ),
            findElement("list-partner-key", feature) &&
              new MenuConfigModel(
                strings.Sidebar.PartnerKey,
                "/partners/partner-key-management",
                "PartnerKeyManagementFeature",
                <LuKeyRound />,
                []
              ),
            !isEmpty(
              feature?.filter(
                (item) =>
                  strings.SupplierFeatureManagement.Service.Mobifone[item?.code]
              )
            ) &&
              new MenuConfigModel(
                strings.Sidebar.SupplierFeature,
                "/partners/suplier-feature-management",
                "SupplierManagementFeature",
                <LuFileCode />,
                []
              ),
            findElement("list-balance-ticket", feature) &&
              new MenuConfigModel(
                strings.Sidebar.BalanceTicket,
                "/partners/balance-ticket-management",
                "BalanceTicketManagementFeature",
                <LuTicketCheck />,
                []
              ),
            findElement("list-delivery-service", feature) &&
              new MenuConfigModel(
                strings.Sidebar.DeliveryService,
                "/partners/delivery-service-management",
                "DeliveryServiceManagementFeature",
                <LuTruck />,
                []
              ),
          ]
        ),
        new MenuConfigModel(
          strings.Sidebar.User,
          "/users",
          "users",
          <LuUsers />,
          [
            findElement("list-user", feature) &&
              new MenuConfigModel(
                strings.UserManagement.Title,
                "/users/user-management",
                "UserManagementFeature",
                <LuUserRound />
              ),
            findElement("list-role", feature) &&
              new MenuConfigModel(
                strings.Sidebar.Role,
                "/users/role-management",
                "RoleManagementFeature",
                <LuFlag />
              ),
            findElement("list-permission", feature) &&
              new MenuConfigModel(
                strings.Sidebar.Permission,
                "/users/permission-management",
                "PermissionManagementFeature",
                <GrDeploy />
              ),
            findElement("list-feature", feature) &&
              new MenuConfigModel(
                strings.Sidebar.Feature,
                "/users/feature-management",
                "FeatureManagementFeature",
                <MdOutlineFeaturedPlayList />
              ),
          ]
        ),
        new MenuConfigModel(
          strings.Sidebar.System,
          "/systems",
          "systems",
          <VscTools />,
          [
            findElement("list-configuration", feature) &&
              new MenuConfigModel(
                strings.Sidebar.Configuration,
                "/systems/configuration-management",
                "ConfigurationManagementFeature",
                <LuSettings />
              ),
            findElement("list-error-code", feature) &&
              new MenuConfigModel(
                strings.Sidebar.ErrorCode,
                "/systems/error-code-management",
                "ErrorCodeManagementFeature",
                <LuCode />,
                []
              ),
            findElement("list-action-log", feature) &&
              new MenuConfigModel(
                strings.ActionLogManagement.Title,
                "/systems/action-log-management",
                "ActionLogManagementFeature",
                <GrActions />,
                []
              ),
            findElement("list-file", feature) &&
              new MenuConfigModel(
                strings.Sidebar.File,
                "/systems/file-management",
                "FilesManagementFeature",
                <LuFileBox />
              ),
          ]
        ),
        new MenuConfigModel(
          strings.Sidebar.Loading,
          "#",
          "loading",
          <LuWebhook />,
          [
            findElement("get-transaction-warehouse", feature) &&
              new MenuConfigModel(
                strings.Sidebar.TransactionWarehouse,
                "/loading-beta/transaction-warehouse",
                "TransactionWarehouseFeature",
                <LuFileArchive />,
                []
              ),
          ]
        ),
      ];
      baseMenu?.forEach((item) => {
        if (item?.componentName !== "StatisticalTransactionFeature") {
          !isEmpty(item?.subMenu?.filter((child) => child !== undefined)) &&
            menuConfig?.push(item);
        } else {
          item !== undefined && menuConfig?.push(item);
        }
      });
      resolve(
        new BaseApiResponseModel<SidebarConfigModel>(
          new SidebarConfigModel(menuConfig),
          undefined,
          undefined,
          undefined,
          undefined,
          undefined
        )
      );
      return menuConfig;
    });
  }
}

export default new SidebarConfigRepository();
